export default __webpack_public_path__ + "static/media/landing-page.e96b64eb.jpg";